import { useHistory } from "../../hooks/useHistory";
import { ListItem } from "@material-ui/core";
import clsx from "clsx";

import { menuOptionsStyles } from "./MenuOption.styles";
import { IMenuOption } from "../NewMenu/useMenuOptions";

interface MenuOptionProps {
  menuOption: IMenuOption;
  className?: string;
  onClick?: () => void;
}

export const MenuOption = ({
  menuOption,
  className,
  onClick,
}: MenuOptionProps) => {
  const { text, Icon, path, joyRideTarget } = menuOption;
  const classes = menuOptionsStyles();
  const history = useHistory();

  return (
    <>
      <ListItem
        className={className || classes.menuLink}
        onClick={onClick}
        data-testid={`opc-${text}`}
        id={joyRideTarget}
      >
        <ListItem
          className={clsx(classes.menuOption, {
            [classes.menuOptionActive]:
              history.location.pathname.includes(path),
          })}
          component="div"
        >
          {Icon}
          <span>{text}</span>
        </ListItem>
      </ListItem>
    </>
  );
};
